<div class="custom-input-text">
  <app-form-lablel class="control-label" [label]="label"></app-form-lablel>
  <mat-form-field class="row-2" appearance="outline">
    <span class="prefix" matPrefix *ngIf="prefix">{{ prefix }} &nbsp;</span>

    <input
      *ngIf="type != 'textarea'"
      matInput
      (paste)="onPaste($event)"
      [disabled]="disabled"
      (keydown)="isNumberKey($event)"
      [maxLength]="maxlength"
      [value]="innerValue"
      #input
      [type]="type"
      [placeholder]="placeholder"
      (blur)="onChange($event, input.value)"
      [autocomplete]="autocomplete"
    />
    <!-- [autocomplete]="visibilityButton ? 'off' : 'on'" -->
    <span
      class="suffix"
      style="top: 0em !important;"
      matSuffix
      *ngIf="suffix"
      >{{ suffix }}</span
    >
    <button
      mat-button
      matSuffix
      type="button"
      *ngIf="visibilityButton"
      mat-icon-button
      aria-label="Clear"
      (click)="changeVisibility()"
    >
      <mat-icon *ngIf="!textIsVisible">visibility</mat-icon>
      <mat-icon *ngIf="textIsVisible">visibility_off</mat-icon>
    </button>

    <textarea
      *ngIf="type == 'textarea'"
      matInput
      [value]="innerValue"
      #input
      [type]="type"
      (blur)="onChange($event, input.value)"
    ></textarea>
  </mat-form-field>
  <mat-error class="row-3" *ngIf="messageError || hasError"
    >{{ messageError }}
  </mat-error>
</div>

<!--
<input [value]="innerValue" #input [type]="type" [placeholder]="placeholder" (blur)="onChange($event, input.value)" [class.error]= "messageError">
<p class="error" *ngIf="messageError"  color="danger">{{messageError}}</p> -->
